import { FC } from "react";
import "./style.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Button from "shared/ui/button";

type PropsType = {
  save: () => void;
  close: () => void;
};

export const SaveProgressBottomsheet: FC<PropsType> = ({ save, close }) => {
  const { t } = useTranslation("onboarding");
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div onClick={close} className="save-progress-bottomsheet">
      <div className="save-progress-main">
        <p>{t("needBreak")}</p>
        <span>{t("progressSaved")}</span>
        <Button onClick={save} variant="dark">
          {t("saveAndLeave")}
        </Button>
        <Button onClick={close}>{t("keepGoing")}</Button>
      </div>
    </div>
  );
};
